import React, {Component} from 'react';
import 'react-table/react-table.css'
import {PROPERTY_API_URL} from '../../constants/api_routes';
import ReactTable from "react-table";
import ListingContainer from "../../containers/listing_container";
import {Button, Header, Icon, Message, Modal, Popup} from "semantic-ui-react";
import Loader from "../universal/loader";
import ViewPropertyDetails from "./view_property_details";
import UpdateProperty from "./update_property_details";
import CreateProperty from "./create_property";

class Properties extends Component {

    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            infoMessage: undefined,
            showMessage: false
        }
    }

    componentWillMount() {
        this.setState({ action: 'listing' });
        if (this.props.selectProperty && !this.props.noLoad) {
            this.props.getList(PROPERTY_API_URL);
        }
    }

    handleView(row) {
        this.setState({action: 'view'});
        this.props.viewDetails(this.props.propertyData.filter((e) => {
            return e.id === row;
        }));
    }

    handleEdit(row) {
        this.setState({action: 'update'});
        this.props.editDetails(this.props.propertyData.filter((e) => {
            return e.id === row;
        }));
    }

    handleDelete(row) {
        this.props.deleteDetail(PROPERTY_API_URL, row);
        this.setState({showConfirm: false});
    }

    handlePropertySelection(row) {
        if (this.props.onPropertySelected) {
            const propertyData = this.props.propertyData.filter((e) => {
                return e.id === row;
            });
            this.props.onPropertySelected(row, propertyData[0]);
        }
    }

    handleBack = (message) => {
        this.setState({ infoMessage: message, action: 'listing' });
        if (this.props.noLoad) {
            this.props.getPropertyAddressList()
        }
    };

    render() {

        const adminColumns = [{
            Header: 'Company',
            accessor: 'company_name',
            filterable: true,
        },  {
            Header: 'Address',
            accessor: 'full_address',
            className:'caddress-width',
            headerClassName:'caddress-width',
            filterable: true
        },{
            Header: 'No.of Ins',
            accessor: 'inspection_count',
            className:' center-aligned micro-width',
            headerClassName:'micro-width',
            filterable:true
            }, {
                Header: 'Size / Furnishings',
                accessor: 'size_furnishings',
                filterable: true,
                className: 'mini-width',
                headerClassName: 'mini-width'
            }, {
                Header: 'Last Inspection Details',
                accessor: 'last_inspection_details',
                filterable: true,
                className: 'medium-width',
                headerClassName: 'medium-width'
            }, {
            Header: 'Action',
            id: 'edit',
            accessor: 'id',
            sortable:false,
            Cell: ({value}) => (
                <div className="center-aligned">
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                    {!this.props.selectProperty || this.props.noLoad ?
                        <Button basic compact icon primary size='mini' onClick={(e) => this.handleEdit(value)}><Icon
                            name='edit'/>Edit</Button> : null
                    }{!this.props.selectProperty && <Popup
                    trigger={<Button basic compact icon negative size='mini'><Icon name='user delete'/></Button>}
                    content={<div>
                             <p>All associated inspections will be lost and cannot be rolled back</p>
                             <Button negative content='Confirm Remove Property?'
                                          onClick={(e) => this.handleDelete(value)}/>
                            </div>}
                    on='click'
                    position='right center'
                    hideOnScroll
                />}
                    {this.props.selectProperty && <Button compact icon primary size='mini'
                                                          onClick={(e) => this.handlePropertySelection(value)}>Choose <Icon
                        name='arrow right'/></Button>}
                </div>
            )
            }];
        
        const agentColumns = [{
            Header: 'Company',
            accessor: 'company_name',
            filterable: true,
        }, {
            Header: 'Address',
            accessor: 'full_address',
            className: 'caddress-width',
            headerClassName: 'caddress-width',
            filterable: true
        }, {
            Header: 'No.of Ins',
            accessor: 'inspection_count',
            className: ' center-aligned micro-width',
            headerClassName: 'micro-width',
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            accessor: 'id',
            sortable: false,
            Cell: ({ value }) => (
                <div className="center-aligned">
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye' />View</Button>
                    {!this.props.selectProperty ?
                        <Button basic compact icon primary size='mini' onClick={(e) => this.handleEdit(value)}><Icon
                            name='edit' />Edit</Button> : null
                    }
                    {/* {!this.props.selectProperty && <Popup
                        trigger={<Button basic compact icon negative size='mini'><Icon name='user delete' /></Button>}
                        content={<div>
                            <p>All associated inspections will be lost and cannot be rolled back</p>
                            <Button negative content='Confirm Remove Property?'
                                onClick={(e) => this.handleDelete(value)} />
                        </div>}
                        on='click'
                        position='right center'
                        hideOnScroll
                    />} */}
                    {this.props.selectProperty && <Button compact icon primary size='mini'
                        onClick={(e) => this.handlePropertySelection(value)}>Choose <Icon
                            name='arrow right' /></Button>}
                </div>
            )
        }];
        
        let columns = adminColumns;
        if (this.props.userRole === 'admin') {
            columns = adminColumns;
        } else if (this.props.userRole === 'agent') {
            columns = agentColumns;
        } else {
            columns = adminColumns;
        }
   




        return (<div className="listing-container pad-top">
                <div style={{display:'flex'}} className="pad-bottom">
                    <div>
                        <Header content="Properties " size='large' textAlign='left'/>
                    </div>
                    <div style={{marginLeft:'1%'}}>
                        {this.state.action === 'listing' &&
                        <Button className={this.props.selectProperty ? "pull-right" : "normal"} primary icon
                                labelPosition='right' onClick={(e) => {
                            this.setState({action: 'create'})
                        }
                        }>Add New Property <Icon name='plus'/>
                        </Button>}
                    </div>
                </div>

                <div className="column twelve">
                {this.props.isFetching &&  !this.props.noLoad && <Loader contain={true} customText={"Loading Properties... Take a long, deep breath"}/>}
                    {this.props.errorMessage && <Message negative onDismiss={() => {
                    }}><Message.Header>{this.props.errorMessage}</Message.Header></Message>}
                    {this.state.infoMessage && <Message positive onDismiss={()=>{this.setState({infoMessage:undefined})}}><Message.Header>{this.state.infoMessage}</Message.Header></Message>}
                    {!this.props.isFetching && this.state.action === 'listing' && this.props.propertyData.length > 0 &&
                    <ReactTable
                        data={this.props.propertyData}
                        columns={columns}
                        defaultFilterMethod={(filter, row) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
                        }}
                        defaultPageSize={100}
                        minRows={12}
                        style={{
                            height:'580px'
                        }}
                        noDataText="No properties found"
                        pageSizeOptions={[5, 10, 20, 25, 50, 100,200,500]}
                    />}

                    <Modal size="large" open={this.state.action !== "listing"} onClose={(e) => {
                        this.setState({action: "listing"})
                    }} style={{minHeight: '500px'}}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                    this.setState({action: "listing"})
                                }}><Icon name="close"/></Button>
                            </div>
                            <Modal.Description>
                                {this.state.action === 'view' &&
                                <ViewPropertyDetails selectedObject={this.props.selectedObject}
                                                     back={this.handleBack} userRole={this.props.userRole}/>}
                                {this.state.action === 'update' &&
                                <UpdateProperty selectedObject={this.props.selectedObject} back={this.handleBack} noLoad={this.props.noLoad}/>}

                                {this.state.action === 'create' &&
                                <CreateProperty selectProperty={this.props.selectProperty} noLoad={this.props.noLoad} back={this.handleBack}/>}

                            </Modal.Description>
                        </Modal.Content>
                    </Modal>

                    {!this.props.isFetching && !(this.props.propertyData.length > 0) &&
                    <div className='center'>No Available Properties. Add property?</div>}

                </div>
            </div>
        );
    }
}

export default ListingContainer(Properties);


// WEBPACK FOOTER //
// ./src/views/properties/index.js